import { AbstractControl } from "@angular/forms";

class CustomValidators {
    constructor(){}

    excellenceCenter(control: AbstractControl) {
        if (control.value == 0) {
            return {
                excellenceCenter: true
            }
        }

        return null;
    }

    supportCenter(control: AbstractControl) {
        if (control.value == 0) {
            return {
                supportCenter: true
            }
        }

        return null;
    }

    responsible(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined') {
            return {
                responsible: true
            }
        }

        return null;
    }

    bp(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined') {
            return {
                bp: true
            }
        }

        return null;
    }

    occupation(control: AbstractControl) {
        if(control.value != 0) {
            return null;
        } else {
            return {
                occupation: true
            }
        }
    }

    position(control: AbstractControl) {
        if(control.value != 0) {
            return null;
        } else {
            return {
                position: true
            }
        }
    }

    kind(control: AbstractControl) {
        if(control.value != 0) {
            return null;
        } else {
            return {
                kind: true
            }
        }
    }
}

const customValidators = new CustomValidators();

export { customValidators };



// WEBPACK FOOTER //
// ./src/app/views/consultants/public-consultant-edit/interfaces/CustomValidators.ts